export default __webpack_public_path__ + "static/media/walken_logo.20d88643.png";